<template>
  <div class="crewHome crewHome-position">
    <div class="crewHome-content crewHome-yover">
      <div class="other-add-title">
        <div class="other-add-code">基本信息</div>
      </div>
      <el-form
        style="margin-top: 20px"
        label-position="top"
        :inline="true"
        :model="baseUser"
        :rules="rules"
        ref="baseUser"
        class="other-add-form"
      >
        <el-form-item label="姓名" prop="userNameCn">
          <el-input
            :disabled="dataDisabled"
            v-model="baseUser.userNameCn"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="idCardNo">
          <el-input
            :disabled="dataDisabled"
            v-model="baseUser.idCardNo"
            placeholder="请输入身份证号"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="cellphoneNo">
          <el-input
            :disabled="dataDisabled"
            v-model="baseUser.cellphoneNo"
            placeholder="请输入手机号码"
          ></el-input>
        </el-form-item>
        <el-form-item label="常用邮箱">
          <el-input
            v-model="baseUser.email"
            placeholder="请输入邮箱号码"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-form
        label-position="top"
        :inline="true"
        :model="baseUser"
        :rules="rules"
        ref="baseUser2"
        class="other-add-form"
      >
        <el-form-item label="性别" prop="sex">
          <!-- <el-input v-model="ruleForm.sex"></el-input> -->
          <el-select
            v-model="baseUser.sex"
            placeholder="请选择性别"
            :disabled="dataDisabled"
          >
            <el-option label="男" value="0"></el-option>
            <el-option label="女" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出生日期" prop="dateOfBirth">
          <el-date-picker
            :disabled="dataDisabled"
            class="other-date-width"
            type="date"
            placeholder="请选择出生日期"
            value-format="yyyy-MM-dd"
            v-model="baseUser.dateOfBirth"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="民族" prop="nation">
          <el-input
            v-model="baseUser.nation"
            placeholder="请输入民族"
          ></el-input>
        </el-form-item>
        <el-form-item label="当前状态">
          <el-select
            v-model="baseUser.crewState"
            placeholder="请选择当前状态"
            :disabled="true"
          >
            <el-option label="在职" value="1"></el-option>
            <el-option label="离职" value="2"></el-option>
            <!-- <el-option label="公休" value="3"></el-option> -->
          </el-select>
        </el-form-item>
      </el-form>
      <el-form
        label-position="top"
        :inline="true"
        :model="baseUser"
        :rules="rules"
        ref="baseUser3"
        class="other-add-form"
      >
        <el-form-item label="健康状况" prop="healthRemark">
          <el-input
            v-model="baseUser.healthRemark"
            placeholder="请输入健康状况"
          ></el-input>
        </el-form-item>
        <el-form-item label="航海经验" prop="sailExperienceId">
          <el-select
            v-model="baseUser.sailExperienceId"
            placeholder="请选择航海经验"
          >
            <el-option
              v-for="item in expList"
              :key="item.sailExperienceId"
              :label="item.sailExperienceName"
              :value="item.sailExperienceId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="籍贯" prop="nativePlace">
          <el-input
            v-model="baseUser.nativePlace"
            placeholder="请输入籍贯"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否婚配" prop="isMarried">
          <el-select v-model="baseUser.isMarried" placeholder="请选择是否婚配">
            <el-option label="未婚" value="0"></el-option>
            <el-option label="已婚" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form
        label-position="top"
        :inline="true"
        :model="baseUser"
        :rules="rules"
        ref="baseUser4"
        class="other-add-form"
      >
        <el-form-item label="家庭住址" prop="homeAddress">
          <el-input
            v-model="baseUser.homeAddress"
            placeholder="请输入家庭住址"
          ></el-input>
        </el-form-item>
        <el-form-item label="毕业院校" prop="highestGraduateSchool">
          <el-input
            v-model="baseUser.highestGraduateSchool"
            placeholder="请输入毕业院校"
          ></el-input>
        </el-form-item>
        <el-form-item label="学历" prop="highestEducation">
          <el-select
            v-model="baseUser.highestEducation"
            placeholder="请选择当前状态"
          >
            <el-option
              v-for="item in degreesList"
              :key="item.code"
              :label="item.itemNameCn"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="毕业时间">
          <el-date-picker
            class="other-date-width"
            type="date"
            placeholder="请选择毕业时间"
            value-format="yyyy-MM-dd"
            v-model="baseUser.highestGraduateTime"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <el-form
        label-position="top"
        :inline="true"
        :model="baseUser"
        :rules="rules"
        ref="baseUser5"
        class="other-add-form"
      >
        <!-- <el-form-item label="船员类型" prop="crewType">
          <el-select v-model="baseUser.crewType" placeholder="请选择员工状态">
            <el-option label="自有船员" value="1"></el-option>
            <el-option label="借调船员" value="2"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="所属劳务公司" prop="userState">
          <el-select
            v-model="baseUser.userState"
            placeholder="请选择所属劳务公司"
          >
            <el-option label="本劳务公司" value="1"></el-option>
            <el-option label="其他劳务公司" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工作服尺寸" prop="waistLine">
          <el-input
            v-model="baseUser.waistLine"
            placeholder="请输入工作服尺寸"
          ></el-input>
        </el-form-item>
        <el-form-item label="工作鞋尺码" prop="shoesSize">
          <el-input
            type="number"
            v-model="baseUser.shoesSize"
            placeholder="请输入工作鞋尺码"
          ></el-input>
        </el-form-item>
        <el-form-item label="家属姓名" prop="emergencyContactName">
          <el-input
            v-model="baseUser.emergencyContactName"
            placeholder="请输入家属姓名"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-form
        label-position="top"
        :inline="true"
        :model="baseUser"
        :rules="rules"
        ref="baseUser6"
        class="other-add-form"
      >
        <el-form-item label="家属联系方式" prop="emergencyContact">
          <el-input
            v-model="baseUser.emergencyContact"
            placeholder="请输入家属联系方式"
          ></el-input>
        </el-form-item>
        <el-form-item label="专业">
          <el-input
            v-model="baseUser.highestMajor"
            placeholder="请输入专业"
          ></el-input>
        </el-form-item>
        <el-form-item label="船员照片">
          <el-upload
            class="upload-demo"
            action
            :http-request="uploadFile"
            :before-upload="beforeUpload"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            multiple
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="fileList"
          >
            <el-button type="primary" class="other-cdit-file"
              ><i class="el-icon-upload2"></i>选择照片</el-button
            >
          </el-upload>
        </el-form-item>
        <el-form-item> </el-form-item>
      </el-form>

      <!-- <el-form
        label-position="top"
        :inline="true"
        :model="baseUser"
        :rules="rules"
        ref="baseUser5"
        class="other-add-form"
      >

        <el-form-item label=""> </el-form-item>
        <el-form-item label=""> </el-form-item>
      </el-form> -->
      <div class="other-add-title">
        <div class="other-add-code">求职意向</div>
      </div>
      <el-form
        style="margin-top: 20px"
        label-position="top"
        :inline="true"
        :model="resumeInfo"
        :rules="rules"
        ref="resumeInfo"
        class="other-add-form"
      >
        <el-form-item label="船舶航区">
          <el-select
            v-model="resumeInfo.naviAreaCode"
            placeholder="请选择船舶航区"
            @change="changeJobPlace(resumeInfo.naviAreaCode)"
          >
            <el-option
              v-for="item in dictList"
              :key="item.code"
              :label="item.itemNameCn"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="意向职位">
          <el-select
            v-model="resumeInfo.positionCode"
            filterable
            placeholder="请选择意向职位"
          >
            <el-option-group
              v-for="group in jobOptions"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.compDutiesCode"
                :label="item.compDutiesName"
                :value="item.compDutiesCode"
              >
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="月薪单位">
          <el-select
            v-model="resumeInfo.salaryType"
            placeholder="请选择月薪单位"
          >
            <el-option label="人民币" value="1"></el-option>
            <el-option label="美元" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="期望月薪">
          <el-col :span="11">
            <el-form-item>
              <el-input
                type="text"
                v-model="resumeInfo.salaryBegin"
                style="width: 44%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="11">
            <el-form-item>
              <el-input
                type="text"
                @blur="changeSalary(resumeInfo.salaryEnd)"
                v-model="resumeInfo.salaryEnd"
                style="width: 45%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
      </el-form>
      <el-form
        label-position="top"
        :inline="true"
        :model="resumeInfo"
        :rules="rules"
        ref="resumeInfo2"
        class="other-add-form"
      >
        <el-form-item label="船舶种类">
          <el-select
            v-model="resumeInfo.shipTypeCode"
            placeholder="请选择船舶种类"
          >
            <el-option
              v-for="val in shipTypeList"
              :key="val.typeId"
              :label="val.shiptypeNameCn"
              :value="val.typeId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="船舶总吨">
          <el-select
            v-model="resumeInfo.recuritShipTonCode"
            placeholder="请选择船舶总吨"
          >
            <el-option
              v-for="val in tonList"
              :key="val.code"
              :label="val.name"
              :value="val.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="登船地点" class="other-ship-place">
          <el-col :span="11">
            <el-form-item style="width: 100%">
              <el-select
                v-model="resumeInfo.locationProvinceCode"
                placeholder="请选择省份"
                @change="city()"
              >
                <el-option
                  v-for="val in porList"
                  :key="val.code"
                  :label="val.name"
                  :value="val.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="2" style="text-align: center">-</el-col>
          <el-col :span="11">
            <el-form-item style="width: 100%">
              <el-select
                v-model="resumeInfo.locationPortCode"
                placeholder="请选择市"
                @change="getPortName()"
              >
                <el-option
                  v-for="val in cityList"
                  :key="val.code"
                  :label="val.itemNameCn"
                  :value="val.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="船龄要求">
          <el-select
            v-model="resumeInfo.shipAgeCode"
            placeholder="请选择船舶总吨"
          >
            <el-option
              v-for="val in ageList"
              :key="val.code"
              :label="val.name"
              :value="val.code"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form
        label-position="top"
        :inline="true"
        :model="resumeInfo"
        :rules="rules"
        ref="resumeInfo3"
        class="other-add-form"
      >
        <el-form-item label="其他说明">
          <el-input
            v-model="resumeInfo.remark"
            placeholder="请输入说明"
          ></el-input>
        </el-form-item>
      </el-form>

      <div class="other-add-title">
        <div class="other-add-code">持有证书</div>
      </div>
      <div class="other-crew-cert">
        <span v-if="crewCertificateList.length == 0"
          >授权后即可获取本人证书</span
        >
        <span v-if="crewCertificateList.length == 0" @click="getCert()"
          >请求授权</span
        >
        <div v-if="crewCertificateList.length > 0">
          <div v-for="item in crewCertificateList" :key="item.id">
            <div class="other-cedit-title">
              <span>{{ item.certTypeName }}</span>
            </div>
            <div class="other-cedit-content" style="margin-top: 6px">
              <span>证书号码:</span>
              <span>{{ item.证书号码 }}</span>
              <span>签发机构:</span>
              <span>{{ item.issueOrgName }}</span>
              <span>有效日期:</span>
              <span
                >{{ item.issueTime }} ~
                {{ item.effectiveTime || "永久有效" }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="other-add-title">
        <div class="other-add-code">工作经历</div>
      </div>
      <div v-for="(item, index) in recruitCyServquali" :key="index">
        <el-form
          style="margin-top: 20px"
          label-position="top"
          :inline="true"
          :model="item"
          :rules="rules"
          ref="itemUser"
          class="other-add-form"
        >
          <el-form-item label="任职单位">
            <el-input
              v-model="item.servCompyName"
              placeholder="请输入任职单位"
            ></el-input>
          </el-form-item>
          <el-form-item label="任职船舶">
            <el-input
              v-model="item.shipName"
              placeholder="请输入船舶名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="任职职位">
            <el-select v-model="item.offiDutyName" placeholder="请选择职位">
              <el-option
                v-for="val in jobList"
                :key="val.postCode"
                :label="val.postName"
                :value="val.postName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="航区">
            <el-select v-model="item.naviAreaCode" placeholder="请选择航区">
              <el-option
                v-for="item in dictList"
                :key="item.code"
                :label="item.itemNameCn"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-form
          label-position="top"
          :inline="true"
          :model="item"
          :rules="rules"
          ref="itemUser2"
          class="other-add-form"
        >
          <el-form-item label="船舶种类">
            <!-- <el-input v-model="item.offiDutyName"></el-input> -->
            <el-select v-model="item.shipTypeCode" placeholder="请选择船舶种类">
              <el-option
                v-for="val in shipTypeList"
                :key="val.typeId"
                :label="val.shiptypeNameCn"
                :value="val.typeId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="船舶总吨">
            <!-- <el-input v-model="item.recuritShipTonName"></el-input> -->
            <!-- <el-select
              v-model="item.recuritShipTonCode"
              placeholder="请选择船舶总吨"
            >
              <el-option
                v-for="val in tonList"
                :key="val.code"
                :label="val.name"
                :value="val.code"
              ></el-option>
            </el-select> -->
            <el-input v-model="item.shipTon" type="number"></el-input>
          </el-form-item>
          <el-form-item label="主机功率">
            <el-input v-model="item.shipZjgl"></el-input>
          </el-form-item>
          <el-form-item label="上船日期">
            <el-date-picker
              class="other-date-width"
              type="date"
              placeholder="请选择上船日期"
              value-format="yyyy-MM-dd"
              v-model="item.offiDate"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <el-form
          label-position="top"
          :inline="true"
          :model="item"
          :rules="rules"
          ref="itemUser3"
          class="other-add-form"
        >
          <el-form-item label="下船日期">
            <el-date-picker
              class="other-date-width"
              type="date"
              placeholder="请选择下船日期"
              value-format="yyyy-MM-dd"
              v-model="item.dismissData"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <span class="other-exp-del" @click="delExp(index)"
              ><i class="el-icon-delete"></i> 删除</span
            >
          </el-form-item>
          <el-form-item label="">
            <!-- <span class="other-exp-del" @click="delExp(index)">删除</span> -->
          </el-form-item>
          <el-form-item label="">
            <!-- <span class="other-exp-del" @click="delExp(index)">删除</span> -->
          </el-form-item>
        </el-form>
      </div>
      <div class="other-crew-experience">
        <span @click="addExp()">+ 添加工作经历</span>
      </div>
      <div class="other-add-title">
        <div class="other-add-code">附件上传</div>
      </div>
      <el-upload
        class="upload-demo"
        action
        :http-request="uploadFile2"
        :before-upload="beforeUpload2"
        :on-preview="handlePreview2"
        :on-remove="handleRemove2"
        :on-change="handleFileChange"
        multiple
        :limit="5"
        :on-exceed="handleExceed2"
        :file-list="fileList2"
        style="margin: 20px 12px"
      >
        <el-button type="primary" class="other-cdit-file"
          ><i class="el-icon-upload2"></i>选择文件</el-button
        >
      </el-upload>
      <!-- <div
        style="
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          margin-left: 12px;
        "
      >
        附件要求:身份证、毕业证书、服务簿
      </div> -->
      <div style="height: 70px"></div>
    </div>
    <div class="other-base-footer">
      <el-button
        type="primary"
        @click="submitForm()"
        style="background: #1a65e2"
        :class="saveCode == '2' ? 'save-code' : ''"
        :disabled="saveCode == '2'"
        >保存</el-button
      >
      <el-button @click="getBack()">返回</el-button>
    </div>
  </div>
</template>
<script>
import {
  saveUserList,
  getDictByType,
  selectDictSailExperienceList,
  selectDictCertPostList,
  selectRecruitDictInfo,
  getTonDict,
  selectShipLocationPortList,
  requestAuthorize,
  getDutyList,
  getShipAgeDict,
  getCrewDetailByIdCardNo,
  getCrewDetail2,
  getOneFile,
} from "@/apis/index";
// multiFileUploads,
import { post } from "@/apis/axios";
import { apiRoot } from "@/config";
import { serveRoot } from "@/config";
const Base64 = require("js-base64").Base64;
export default {
  data() {
    return {
      dataDisabled: false,
      ruleForm: {},
      baseUser: {
        crewState: "2",
      },
      ageList: [],
      rules: {
        userNameCn: [
          { required: true, message: "请输入名称", trigger: "blur" },
          { min: 2, max: 6, message: "长度在 2 到 6 个字符", trigger: "blur" },
        ],
        idCardNo: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          { validator: this.validateIdNumber, trigger: "blur" },
        ],
        cellphoneNo: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: this.validateCellphoneNo, trigger: "blur" },
        ],
        // crewType: [
        //   { required: true, message: "请选择船员类型", trigger: "blur" },
        // ],
        userState: [
          {
            required: true,
            message: "请选择员工所属劳务公司",
            trigger: "blur",
          },
        ],
        dateOfBirth: [
          { required: true, message: "请选择出生日期", trigger: "blur" },
        ],
        nation: [{ required: true, message: "请输入民族", trigger: "blur" }],
        healthRemark: [
          { required: true, message: "请输入健康状况", trigger: "blur" },
        ],
        sailExperienceId: [
          { required: true, message: "请选择航海经验", trigger: "blur" },
        ],
        nativePlace: [
          { required: true, message: "请输入籍贯", trigger: "blur" },
        ],
        isMarried: [
          { required: true, message: "请选择是否婚配", trigger: "blur" },
        ],
        homeAddress: [
          { required: true, message: "请输入家庭住址", trigger: "blur" },
        ],
        highestGraduateSchool: [
          { required: true, message: "请输入毕业院校", trigger: "blur" },
        ],
        highestEducation: [
          { required: true, message: "请选择学历", trigger: "blur" },
        ],
        waistLine: [
          { required: true, message: "请输入工作服尺寸", trigger: "blur" },
        ],
        shoesSize: [
          { required: true, message: "请输入工作鞋尺码", trigger: "blur" },
          { validator: this.validateshoesSize, trigger: "blur" },
        ],
        emergencyContactName: [
          { required: true, message: "请输入家属姓名", trigger: "blur" },
        ],
        emergencyContact: [
          { required: true, message: "请输入家属联系方式", trigger: "blur" },
          { validator: this.validateContact, trigger: "blur" },
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "blur" }],
      },
      fileList: [],
      fileList2: [],
      dialogVisible: false,
      recruitCyServquali: [],
      fileType: ["png", "jpg", "bmp", "jpeg", "ceb"],
      fileType2: [
        "pdf",
        "doc",
        "docx",
        "xls",
        "xlsx",
        "txt",
        "png",
        "jpg",
        "bmp",
        "jpeg",
        "ceb",
      ],
      resumeInfo: {},
      degreesList: [],
      expList: [],
      jobList: [],
      shipTypeList: [],
      dictList: [
        {
          code: "2",
          itemNameCn: "沿海航区",
        },
        {
          code: "4",
          itemNameCn: "无限航区",
        },
        {
          code: "N",
          itemNameCn: "内河",
        },
        {
          code: "D",
          itemNameCn: "东南亚航区",
        },
      ],
      porList: [],
      tonList: [],
      cityList: [],
      checkVisible: true,
      jobOptions: [
        {
          label: "其他",
          options: [],
        },
        {
          label: "轮机",
          options: [],
        },
        {
          label: "通信",
          options: [],
        },
        {
          label: "驾驶",
          options: [],
        },
      ],
      fileReat: [],
      crewCertificateList: [],
      cardNum: "",
      cellNum: "",
      savaType: "1",
      saveCode: "1",
      listUserId: "",
    };
  },
  mounted() {
    if (this.$route.params.userId != 0) {
      this.listUserId = this.$route.params.userId;
      this.getCrewDetailList();
    }
    if (this.$route.params.userId == 0) {
      this.$set(this.baseUser, "userState", "1");
    }
    this.getDregssList();
    this.selectDictSailExperienceLists();
    this.selectDictCertPostLists();
    this.selectRecruitDictInfoList();
    this.getTonDictList();
    this.getShipAgeDictList();
    this.selectShipLocationPortLists();
  },
  methods: {
    changeJobPlace(type) {
      this.getDutyListList(type);
    },
    async getDutyListList(type) {
      this.$set(this.resumeInfo, "positionCode", "");
      const res = await getDutyList({ naviArea: type });
      this.jobOptions[0].options = res.data["其他"] || "";
      this.jobOptions[1].options = res.data["轮机"] || "";
      this.jobOptions[2].options = res.data["通信"] || "";
      this.jobOptions[3].options = res.data["驾驶"] || "";
      // this.companyList = res.data;
    },
    async getDutyListListDetail(type) {
      // this.$set(this.resumeInfo, "positionCode", "");
      const res = await getDutyList({ naviArea: type });
      this.jobOptions[0].options = res.data["其他"] || "";
      this.jobOptions[1].options = res.data["轮机"] || "";
      this.jobOptions[2].options = res.data["通信"] || "";
      this.jobOptions[3].options = res.data["驾驶"] || "";
      // this.companyList = res.data;
    },
    async getCrewDetailList() {
      let userId = this.$route.params.userId;
      const res = await getCrewDetail2({ userId: userId });
      this.baseUser = res.data.compyUserInfo || {};
      this.resumeInfo = res.data.resumeInfo || {};
      this.crewCertificateList = res.data.crewCertificateList || [];
      this.recruitCyServquali = res.data.recruitCyServqualiList || [];
      if (this.baseUser.userPhoto) {
        this.fileList = [
          { fileUrl: this.baseUser.userPhoto, name: "照片", upload: "1" },
        ];
      }
      if (this.resumeInfo.naviAreaCode) {
        this.getDutyListListDetail(this.resumeInfo.naviAreaCode);
      }
      if (this.baseUser.relateFile) {
        let relateUrl = JSON.parse(this.baseUser.relateFile);
        relateUrl.forEach((item) => {
          item.upload = "1";
          item.name = item.fileName;
        });
        this.fileList2 = relateUrl;
      }
      if (this.resumeInfo.locationProvinceCode) {
        this.city();
      }
    },
    async getCrewDetailByIdCardNoList(id, phone) {
      const res = await getCrewDetailByIdCardNo({
        idCardNo: id,
        cellPhoneNo: phone,
      });
      if (res.data) {
        this.dataDisabled = true;
        this.$message.success("系统检测到该用户已存在，已拉取该用户信息");
        this.baseUser = res.data.compyUserInfo || {};
        this.resumeInfo = res.data.resumeInfo || {};
        this.recruitCyServquali = res.data.recruitCyServqualiList || [];
        this.crewCertificateList = res.data.crewCertificateList || [];
        if (this.baseUser.userPhoto) {
          this.fileList = [{ fileUrl: this.baseUser.userPhoto, name: "照片" }];
        }
        if (this.resumeInfo.naviAreaCode) {
          this.getDutyListListDetail(this.resumeInfo.naviAreaCode);
        }
        if (this.baseUser.relateFile) {
          let relateUrl = JSON.parse(this.baseUser.relateFile);
          relateUrl.forEach((item) => {
            item.upload = "1";
          });
          this.fileList2 = relateUrl;
        }
        if (this.resumeInfo.locationProvinceCode) {
          this.city();
        }
      }
      if (res.code == 0) {
        this.$message({
          type: "warning",
          message: res.msg,
        });
        this.saveCode = "2";
      }
      if (res.code == 1) {
        this.saveCode = "1";
      }
    },
    changeSalary(value) {
      if (value * 1 < this.resumeInfo.salaryBegin * 1) {
        this.$message.error("请输入正确数值");
        this.$set(this.resumeInfo, "salaryEnd", "");
      }
    },
    //身份证
    validateIdNumber(rule, value, callback) {
      const regex = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/;
      if (!value || regex.test(value)) {
        // 验证通过
        var year = value.substr(6, 4); // 年份
        var month = value.substr(10, 2); // 月份
        var day = value.substr(12, 2); // 日
        this.$set(this.baseUser, "dateOfBirth", year + "-" + month + "-" + day);
        if (value.length == 15) {
          this.$set(this.baseUser, "sex", ["1", "0"][value.substr(14, 1) % 2]);
          // this.baseUser.sex = ["1", "0"][value.substr(14, 1) % 2];
        } else if (value.length == 18) {
          this.$set(this.baseUser, "sex", ["1", "0"][value.substr(16, 1) % 2]);
          // this.baseUser.sex = ["1", "0"][value.substr(16, 1) % 2];
        }
        this.cardNum = value;
        if (this.cardNum && this.cellNum && this.savaType == "1") {
          this.getCrewDetailByIdCardNoList(this.cardNum, this.cellNum);
        }
        callback();
      } else {
        // 验证未通过，传入错误信息
        callback(new Error("请输入正确的身份证号"));
      }
    },
    //手机号
    validateCellphoneNo(rule, value, callback) {
      const regex = /^1[3-9]\d{9}$/;
      if (!value || regex.test(value)) {
        // 验证通过
        this.cellNum = value;
        if (this.cardNum && this.cellNum && this.savaType == "1") {
          this.getCrewDetailByIdCardNoList(this.cardNum, this.cellNum);
        }
        callback();
      } else {
        // 验证未通过，传入错误信息
        callback(new Error("请输入正确的手机号"));
      }
    },
    //手机号
    validateContact(rule, value, callback) {
      const regex = /^1[3-9]\d{9}$/;
      if (!value || regex.test(value)) {
        // 验证通过
        callback();
      } else {
        // 验证未通过，传入错误信息
        callback(new Error("请输入正确的手机号"));
      }
    },
    validateshoesSize(rule, value, callback) {
      const regex = /^\d{1,2}$/;
      if (!value || regex.test(value)) {
        // 验证通过
        callback();
      } else {
        // 验证未通过，传入错误信息
        callback(new Error("请输入正确的工作鞋尺码"));
      }
    },
    addExp() {
      this.recruitCyServquali.push({});
    },
    delExp(index) {
      const indexToDelete = index; // 要删除的索引位置

      this.recruitCyServquali.splice(indexToDelete, 1);
    },
    //学历
    async getDregssList() {
      const res = await getDictByType();
      this.degreesList = res.data;
    },
    //经历
    async selectDictSailExperienceLists() {
      const res = await selectDictSailExperienceList();
      this.expList = res.data;
    },
    //职位
    async selectDictCertPostLists() {
      const res = await selectDictCertPostList();
      this.jobList = res.data;
    },
    //船舶种类
    async selectRecruitDictInfoList() {
      const res = await selectRecruitDictInfo();
      this.shipTypeList = res.data.cbShipParentTypeList;
    },
    uploadFile(file) {
      let fileData = new FormData();
      fileData.delete("uploadFiles");
      fileData.append("uploadFiles", file.file);
      // let obj = {
      //   fileName: file.name,
      //   fileSrc: "",
      //   data: fileData,
      // };
      post(`${apiRoot}/file/singleFileUpload`, fileData, { upload: true })
        .then((res) => {
          // message.success({
          //   content: "上传成功",
          //   duration: 3
          // });
          this.baseUser.userPhoto = res.data;
          // this.baseParams.appendixUrl = res.data;
          // this.params.appendixUrl = res.data;
        })
        .catch(() => {});
      // console.log(obj);
      // console.log(file.file, "sb2");
    },
    beforeUpload(file) {
      // console.log(file);
      if (file.type != "" || file.type != null || file.type != undefined) {
        //截取文件的后缀，判断文件类型
        const FileExt = file.name.replace(/.+\./, "").toLowerCase();
        //计算文件的大小
        const isLt5M = file.size / 1024 / 1024 < 30; //这里做文件大小限制
        //如果大于50M
        if (!isLt5M) {
          this.$showMessage("上传文件大小不能超过 30MB!");
          return false;
        }
        //如果文件类型不在允许上传的范围内
        if (this.fileType.includes(FileExt)) {
          return true;
        } else {
          this.$message.error("上传文件格式不正确!");
          return false;
        }
      }
    },
    // 点击文件
    handlePreview(file) {
      // console.log(file);
      if (file.upload == "1") {
        this.openShipFile(file.fileUrl);
      }

      // window.open(file.url.data);
    },
    async openShipFile(src) {
      let res = await getOneFile({
        fileName: src[0] == "/" ? "file" + src : "file/" + src,
      });
      window.open(res.data);
    },
    //删除文件
    handleRemove(i) {
      // console.log(file, fileList);
      this.fileList.splice(i, 1);
    },
    //超出文件个数的回调
    handleExceed() {
      this.$message({
        type: "warning",
        message: "超出最大上传文件数量的限制！",
      });
      return;
    },
    handleFileChange(file, fileList) {
      // console.log(file);
      console.log(fileList);
      this.fileList2 = fileList;
    },
    uploadFile2(file) {
      console.log(file);
      // this.fileList2.push(file);
      // console.log(fileList);
      // var nums = [];
      // var oData = new FormData();
      // this.fileList2.forEach((item, index) => {
      //   oData.append("uploadFileList", item.data);
      //   nums.push(index);
      // });

      // let fileData = new FormData();
      // fileData.delete("uploadFiles");
      // fileData.append("uploadFiles", file.file);
      // let obj = {
      //   fileName: file.name,
      //   fileSrc: "",
      //   data: fileData,
      // };
      // post(`${apiRoot}/file/singleFileUpload`, fileData, { upload: true })
      //   .then((res) => {
      //     // message.success({
      //     //   content: "上传成功",
      //     //   duration: 3
      //     // });
      //     this.baseUser.relateFile = res.data;
      //   })
      //   .catch(() => {});
      // console.log(obj);
      // console.log(file.file, "sb2");
    },
    beforeUpload2(file) {
      console.log(file);
      if (file.type != "" || file.type != null || file.type != undefined) {
        //截取文件的后缀，判断文件类型
        const FileExt = file.name.replace(/.+\./, "").toLowerCase();
        //计算文件的大小
        const isLt5M = file.size / 1024 / 1024 < 30; //这里做文件大小限制
        //如果大于50M
        if (!isLt5M) {
          this.$showMessage("上传文件大小不能超过 30MB!");
          return false;
        }
        //如果文件类型不在允许上传的范围内
        if (this.fileType2.includes(FileExt)) {
          return true;
        } else {
          this.$message.error("上传文件格式不正确!");
          return false;
        }
      }
    },
    // 点击文件
    handlePreview2(file) {
      // console.log(file);
      // window.open(file.url.data);
      if (file.upload == "1") {
        this.openShipFile(file.fileUrl);
      }
    },
    //删除文件
    handleRemove2(file, fileList) {
      console.log(file);
      this.fileList2 = fileList;
      // this.fileList2.splice(i, 1);
    },
    //超出文件个数的回调
    handleExceed2() {
      this.$message({
        type: "warning",
        message: "超出最大上传文件数量的限制！",
      });
      return;
    },
    submitForm() {
      this.savaType = "2";

      if (this.dataDisabled) {
        this.$refs.baseUser5.validate((val) => {
          this.$refs.baseUser2.validate((el) => {
            this.$refs.baseUser3.validate((li) => {
              this.$refs.baseUser4.validate((lo) => {
                this.$refs.baseUser5.validate((uy) => {
                  this.$refs.baseUser6.validate((yt) => {
                    if (val && el && li && lo && uy && yt) {
                      if (this.fileList2.length > 0) {
                        var nums = [];
                        var oData = new FormData();
                        this.fileList2.forEach((item, index) => {
                          if (item.upload != "1") {
                            oData.append("uploadFileList", item.raw);
                            oData.append("FileName", item.name);
                            nums.push(index);
                          } else {
                            this.fileReat.push({
                              fileName: item.fileName,
                              fileUrl: item.fileUrl,
                            });
                          }
                        });

                        post(`${apiRoot}/file/multiFileUploads`, oData, {
                          upload: true,
                        })
                          .then((res) => {
                            // this.fileReat = res.data;
                            if (res.data) {
                              res.data.forEach((item) => {
                                this.fileReat.push({
                                  fileName: item.fileName,
                                  fileUrl: item.fileUrl,
                                });
                              });
                            }
                            // console.log(this.fileReat);
                            this.save();
                            // this.baseUser.relateFile = res.data;
                          })
                          .catch(() => {
                            this.save();
                          });
                      } else {
                        this.save();
                      }
                    }
                  });
                });
              });
            });
          });
        });
      } else {
        this.$refs.baseUser.validate((valid) => {
          this.$refs.baseUser5.validate((val) => {
            this.$refs.baseUser2.validate((el) => {
              this.$refs.baseUser3.validate((li) => {
                this.$refs.baseUser4.validate((lo) => {
                  this.$refs.baseUser5.validate((uy) => {
                    this.$refs.baseUser6.validate((yt) => {
                      if (valid && val && el && li && lo && uy && yt) {
                        this.savaType = "1";
                        if (this.fileList2.length > 0) {
                          var nums = [];
                          var oData = new FormData();
                          console.log(this.fileList2);
                          this.fileList2.forEach((item, index) => {
                            // oData.append("uploadFileList", item.raw);
                            // oData.append("FileName", item.name);
                            // nums.push(index);
                            if (item.upload != "1") {
                              oData.append("uploadFileList", item.raw);
                              oData.append("FileName", item.name);
                              nums.push(index);
                            } else {
                              this.fileReat.push({
                                fileName: item.fileName,
                                fileUrl: item.fileUrl,
                              });
                            }
                          });
                          console.log(123, this.fileReat);
                          post(`${apiRoot}/file/multiFileUploads`, oData, {
                            upload: true,
                          })
                            .then((res) => {
                              if (res.data) {
                                res.data.forEach((item) => {
                                  this.fileReat.push({
                                    fileName: item.fileName,
                                    fileUrl: item.fileUrl,
                                  });
                                });
                              }
                              // console.log(this.fileReat);
                              this.save();
                              // this.baseUser.relateFile = res.data;
                            })
                            .catch(() => {
                              this.save();
                            });
                        } else {
                          this.save();
                        }
                        //
                        // 表单验证通过，执行提交逻辑
                        // ...
                      } else {
                        // 表单验证未通过
                      }
                    });
                  });
                });
              });
            });
          });
        });
      }
    },
    //sumbit
    async save() {
      // if (this.recruitCyServquali.length > 0) {
      //   this.recruitCyServquali.forEach((item) => {
      //     if (!item.servCompyName) {
      //       this.$message({
      //         message: "请输入任职单位",
      //         type: "warning",
      //       });
      //     } else if (!item.shipName) {
      //       this.$message({
      //         message: "请输入船舶名称",
      //         type: "warning",
      //       });
      //     } else if (!item.offiDutyName) {
      //       this.$message({
      //         message: "请选择任职职位",
      //         type: "warning",
      //       });
      //     } else if (!item.naviAreaCode) {
      //       this.$message({
      //         message: "请选择航区",
      //         type: "warning",
      //       });
      //     } else if (!item.shipTypeCode) {
      //       this.$message({
      //         message: "请选择船舶种类",
      //         type: "warning",
      //       });
      //     } else if (!item.recuritShipTonCode) {
      //       this.$message({
      //         message: "请选择船舶总吨",
      //         type: "warning",
      //       });
      //     } else if (!item.shipZjgl) {
      //       this.$message({
      //         message: "请选择主机功率",
      //         type: "warning",
      //       });
      //     } else if (!item.offiDate) {
      //       this.$message({
      //         message: "请选择上船日期",
      //         type: "warning",
      //       });
      //     } else if (!item.dismissData) {
      //       this.$message({
      //         message: "请选择下船日期",
      //         type: "warning",
      //       });
      //     }
      //   });
      // }
      console.log(this.fileReat);
      if (this.fileReat.length > 0) {
        this.baseUser.relateFile = JSON.stringify(this.fileReat);
      }
      // try {
      const res = await saveUserList({
        compyUserInfo: this.baseUser,
        recruitCyServqualiList: this.recruitCyServquali,
        resumeInfo: this.resumeInfo,
      });
      // console.log(res);
      if (res.code == 1) {
        this.$message({
          message: "保存成功",
          type: "success",
        });
        this.$router.push({ name: "船员库" });
      } else {
        this.$message({
          message: res.msg,
          type: "warning",
        });
      }
    },
    //登船地点
    async selectShipLocationPortLists() {
      const res = await selectShipLocationPortList();
      // console.log(res);
      this.porList = res.data;
    },
    //总吨
    async getTonDictList() {
      const res = await getTonDict();
      // console.log(res);
      this.tonList = res.data;
    },
    //船龄
    async getShipAgeDictList() {
      const res = await getShipAgeDict();
      // console.log(res);
      this.ageList = res.data;
    },
    city() {
      if (!this.resumeInfo.locationProvinceCode) {
        this.cityList = [];
      } else {
        this.porList.forEach((item) => {
          if (this.resumeInfo.locationProvinceCode == item.code) {
            this.cityList = item.chirld;
            this.resumeInfo.locationProvinceName = item.name;
          }
        });
      }
    },
    getPortName() {
      this.cityList.forEach((item) => {
        if (this.resumeInfo.locationPortCode == item.code) {
          this.resumeInfo.locationPortName = item.itemNameCn;
        }
      });
    },
    getBack() {
      this.$router.push({ name: "船员库" });
    },
    async getCert() {
      if (!this.baseUser.cellphoneNo) {
        this.$message({
          message: "请输入手机号码",
          type: "warning",
        });
        return;
      }
      if (!this.baseUser.idCardNo) {
        this.$message({
          message: "请输入身份证号",
          type: "warning",
        });
        return;
      }
      if (this.checkVisible == false) {
        this.$message({
          message: "请求授权中",
          type: "warning",
        });
        return;
      }
      const companyId = Base64.encode(sessionStorage.getItem("companyId"));
      const idCardNo = Base64.encode(this.baseUser.idCardNo);
      const res = await requestAuthorize({
        authorizeType: "1",
        cellPhoneNo: this.baseUser.cellphoneNo,
        idCardNo: this.baseUser.idCardNo,
        url: serveRoot + `/#/passCert?companyId=${companyId}&id=${idCardNo}`,
      });
      if (res) {
        this.checkVisible = false;
        this.$message({
          message: "请求授权成功",
          type: "success",
        });
      }
      // console.log(res);
      this.tonList = res.data;
    },
    //添加工作经历
  },
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 0.5em;
  height: 0.5em;
}

/* 隐藏滚动条轨道 */
::-webkit-scrollbar-track {
  background-color: transparent;
}

/* 隐藏滚动条滑块 */
::-webkit-scrollbar-thumb {
  background-color: transparent;
}
</style>
